import { EMPTY_STRING } from '../shared/constants/constants';
import { sanitizeFilename } from '../shared/helpers/securityHelpers';
import axios, { AxiosResponseHeaders, AxiosHeaders } from 'axios';

interface ReportResponse {
	type?: string;
	status?: number;
}

export const getFileNameFromHeader = (headers: AxiosResponseHeaders | AxiosHeaders | Record<string, any>): string => {
	let fileName = '';
	let disposition: string | undefined;

	if (headers instanceof AxiosHeaders) {
		const headerValue = headers.get('content-disposition');
		disposition = typeof headerValue === 'string' ? headerValue : undefined;
	} else if (typeof headers === 'object' && headers !== null) {
		disposition = headers['content-disposition'];
	}

	if (disposition && disposition.indexOf('attachment') !== -1) {
		const filenameRegex = /file[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = filenameRegex.exec(disposition);
		if (matches && matches[1]) {
			fileName = matches[1].replace(/['"]/g, EMPTY_STRING);
		}
	}
	return fileName;
};

export const downloadFile = (headers: string, blob: Blob): void => {
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	// Sanitize filename to prevent XSS attacks (CWE-80)
	// Use detached element click to avoid appendChild DOM sink
	link.download = sanitizeFilename(headers);
	link.click();
	window.URL.revokeObjectURL(url);
};

export const ReportsApi = {
	async resetParams(processId: string, reportType: string): Promise<ReportResponse> {
		return axios({
			method: 'PUT',
			url: `/api/v1/batch/export/reset/${processId}?type=${reportType}`,
		})
			.then(response => {
				if (response.status === 200) {
					return response.data;
				}
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},

	async getGenerateReportsParams(processId: string, reportType: string): Promise<void> {
		return axios({
			method: 'GET',
			url: `/api/v1/batch/export/sync/${processId}?type=${reportType}`,
		})
			.then(response => {
				if (response.status === 200) {
					downloadFile(getFileNameFromHeader(response.headers), new Blob([response.data]));
				}
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},
};
